import { Component, OnDestroy, OnInit } from '@angular/core';
import { IPageHeader } from '@modeso/aumico-lib-core-fe';
import { GetOrganizationDto, OrganizationProvider } from '@modeso/aumico-lib-users-fe';
import Debug from 'debug';
import { Subject, filter, switchMap, take, tap } from 'rxjs';
import { FCPState } from '../../../../../../aumico-lib-users-fe/src/lib/enums/subscription-state.enum';
import { Paths } from '../../../enums/paths.enum';
import { RouteLabels } from '../../../enums/routeLabels.enum';
const debug = Debug('aumico:OrganizationSettingsPage');

@Component({
    selector: 'app-financial-statement-edit',
    template: `<app-aumico-layout>
        <ng-container header>
            <ham-page-header [title]="pageHeader.value" [hasBackButton]="false"></ham-page-header>
            <ham-page-tab-navigation [navigationItems]="activeNavigationTabs"></ham-page-tab-navigation>
        </ng-container>
        <ng-container content>
            <router-outlet></router-outlet>
        </ng-container>
    </app-aumico-layout>`,
})
export class OrganizationSettingsPage implements OnInit, OnDestroy {
    //labels
    public activeNavigationTabs: {
        routerLink: string;
        tabLabelKey: string;
    }[] = [
            {
                routerLink: Paths.TEXT_SNIPPETS,
                tabLabelKey: RouteLabels.TEXT_SNIPPETS,
            },
            {
                routerLink: Paths.ORGANIZATION_USERS,
                tabLabelKey: RouteLabels.ORGANIZATION_USERS,
            },
            {
                routerLink: Paths.SETTINGS,
                tabLabelKey: RouteLabels.DESIGN_SETTINGS,
            },
            {
                routerLink: Paths.ORGANIZATION_PROFILE,
                tabLabelKey: RouteLabels.ORGANIZATION_PROFILE,
            },
            {
                routerLink: Paths.ORGANIZATION_SUBSCRIPTION,
                tabLabelKey: RouteLabels.ORGANIZATION_SUBSCRIPTION,
            },
            {
                routerLink: Paths.ORGANIZATION_2FA,
                tabLabelKey: RouteLabels.TWO_FACTOR_AUTHENTICATION,
            },
            {
                routerLink: Paths.AI_SETTINGS,
                tabLabelKey: RouteLabels.AI_SETTINGS,
            },
            {
                routerLink: Paths.INTEGRATIONS,
                tabLabelKey: RouteLabels.INTEGRATIONS,
            },
        ];

    pageHeader: IPageHeader = {
        isLocalizedKey: true,
        value: RouteLabels.ORGANIZATION_SETTINGS,
    };

    private unsubscribe$ = new Subject<void>();

    constructor(private organizationProvider: OrganizationProvider) { }

    ngOnInit(): void {
        // first grab the org once so we can set the breadcrumb and FCP‐related tab
        this.organizationProvider
            .getCurrentOrganization$()
            .pipe(
                filter((org) => !!org),
                take(1),
                tap((organization: GetOrganizationDto) => {
                    // FCP tab (as you already had)
                    const isFcpActive = [FCPState.PAID, FCPState.TRIAL].includes(
                        organization.fcpActivationDetails?.subscriptionState,
                    );
                    if (isFcpActive) {
                        this.activeNavigationTabs.push({
                            tabLabelKey: RouteLabels.CHECKLISTS,
                            routerLink: Paths.CHECKLISTS,
                        });
                    }
                }),
                // once we've done that, switch over to the CPMM flag
                switchMap(() => this.organizationProvider.cpmmIsActive$().pipe(take(1))),
            )
            .subscribe((isCpmmActive) => {
                if (isCpmmActive) {
                    this.activeNavigationTabs.push(
                        {
                            routerLink: Paths.MANDATE_MANAGEMENT,
                            tabLabelKey: RouteLabels.MANDATE_MANAGEMENT,
                        },
                        {
                            routerLink: Paths.CLOSING_WORKFLOW_OVERVIEW,
                            tabLabelKey: RouteLabels.CLOSING_WORKFLOW,
                        },
                    );
                }
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
